/*jshint multistr: true */

import '../../lib/stickyfill.js';

function stickyFill() {
    var sticky = $('.js_sticky');

    if (!sticky.length) return;

    try {
        if (typeof sticky.Stickyfill === 'function') {
            sticky.Stickyfill();
        }
    } catch (e) {
        console.warn('[stickyFill] failed', e);
    }
}

// Maintain legacy global access expected by other legacy modules (e.g., load_more.js)
if (typeof window !== 'undefined') {
    window.stickyFill = stickyFill;
}

export { stickyFill };
